module.exports = __webpack_public_path__ + "img/instagram-logo.f55f4de9.svg";